import React from "react";
import CardPageLayout from "./CardPageLayout";

const LjusetPage = () => (
  <CardPageLayout
    splashCardId="ljuset"
    title="- Ljuset -"
    ctaTo="/"
    ctaLabel="Utforska Livskraft"
  >
    <p className="card-page-text">Det finns en version av dig som mår bra.</p>
    <p className="card-page-text">
      Den är inte perfekt eller symptomfri till varje pris.
    </p>
    <p className="card-page-text">
      Det kortet du håller i påminner dig om att du kan må bättre.
    </p>
    <p className="card-page-text">
      Det är ett mål och du går i rätt riktning, du är närmare än du tror.
    </p>
  </CardPageLayout>
);

export default LjusetPage;
